import { STATUS_LABELS, type Priority, type Status } from '@helpdesk/shared';
import { Clock } from 'lucide-react';

const STATUS_STYLES: Record<Status, string> = {
  open: 'bg-info-soft text-info',
  in_progress: 'bg-warning-soft text-warning',
  waiting: 'bg-violet-soft text-violet',
  resolved: 'bg-brand-soft text-brand-ink',
  closed: 'bg-surface-2 text-muted',
  void: 'bg-surface-2 text-muted line-through',
};

/** Staff see friendlier wording for "waiting". */
const STAFF_LABELS: Partial<Record<Status, string>> = { waiting: 'Needs your reply', void: 'Cancelled' };

export function StatusBadge({ status, forStaff = false }: { status: Status; forStaff?: boolean }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${STATUS_STYLES[status]}`}
    >
      {(forStaff && STAFF_LABELS[status]) || STATUS_LABELS[status]}
    </span>
  );
}

const PRIORITY_STYLES: Record<Priority, string> = {
  Critical: 'text-danger',
  High: 'text-warning',
  Medium: 'text-info',
  Low: 'text-muted',
};

export function PriorityBadge({ priority }: { priority: Priority }) {
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-semibold ${PRIORITY_STYLES[priority]}`}>
      <span className="size-2 rounded-full bg-current" aria-hidden />
      {priority}
    </span>
  );
}

export function OverdueBadge() {
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-danger-soft px-2 py-0.5 text-xs font-semibold text-danger">
      <Clock className="size-3" aria-hidden />
      Overdue
    </span>
  );
}

/** Staff's own phone or a favour: no deadline, handled in the personal-help slot. */
export function PersonalBadge() {
  return (
    <span className="inline-flex items-center rounded-full bg-violet-soft px-2 py-0.5 text-xs font-semibold text-violet">
      Personal
    </span>
  );
}
